<template>
  <v-data-table
    :headers="headers"
    :items="itens"
    :fixed-header="true"
    :search="search"
    :items-per-page="50"
    item-key="id"
    class="table-orcamento-resposivo"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Comprador</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          outlined
          single-line
          hide-details
          clearable
          v-lazy-input:debounce="400"
          class="pr-4 pl-4 search"
        ></v-text-field>
        <v-menu>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-btn
              color="white"
              v-bind="attrs"
              v-on="{ ...menu }"
              height="39px"
              class="mr-4"
            >
              <v-icon color="grey" left>mdi-filter</v-icon>
              {{ ano.text }}
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in selects.ano"
              :key="index"
              @click="menuItem(item)"
            >
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <comprador-show :item="item" @eItem="mItem" />
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-btn icon title="Editar Item" @click="editar(item)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn icon title="Remover Item" @click="excluir(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import compradorShow from "./compradorShow.vue";
import moment from "moment";

export default {
  components: { compradorShow },
  data() {
    return {
      item: "",
      headers: [
        { text: "Ano", value: "ano", width: "120px", align: "center" },
        {
          text: "ID Comprador",
          value: "comprador_id",
          width: "125px",
          align: "center",
        },
        { text: "Comprador", value: "comprador" },
        {
          text: "Total Previsto Compra Anual",
          value: "total_previsto_compra",
          width: "230px",
          align: "center",
        },
        { value: "action", sortable: false, width: "100px", align: "center" },
      ],
      search: "",
    };
  },
  computed: {
    ...mapGetters("orcComprador", ["itens", "selects", "ano"]),
  },
  created() {
    this.$store.dispatch(
      "loading/addRequisicao",
      this.$store.dispatch("orcComprador/Itens", { ano: this.ano, group: true })
    );
    this.$store.dispatch("orcComprador/Compradores");

    let start = moment().format("YYYY");
    start = moment().subtract("2", "years").format("YYYY");
    let end = moment().add("2", "years").format("YYYY");
    this.selects.ano = this.selects.ano.filter(
      (s) => s.value >= start && s.value <= end
    );
  },
  methods: {
    excluir(item) {
      if (confirm("Deseja remover aplicativo?")) {
        this.$store.dispatch("orcComprador/Delete", {
          ano: item.ano,
          comprador_id: item.comprador_id,
        });
      }
    },
    editar(prop) {
      this.item = prop;
    },
    menuItem(prop) {
      this.$store.dispatch("orcComprador/Itens", { ano: prop, group: true });
    },
    mItem() {
      this.item = "";
    },
  },
};
</script>
